<div 
  [ngClass]="dropZoneClasses()"
  [ngStyle]="dropZoneStyles()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  (click)="onZoneClick()">
  
  <input
    type="file"
    [multiple]="multiple()"
    hidden
    #fileInput
    [disabled]="effectiveDisabled()"
    [id]="idInput()"
    (change)="onFileSelected($event)"
    [accept]="acceptedExtensions()">

  @if (showFileList() && hasFiles()) {
    <div
      class="so-filedrop__file-list"
      [style.--so-filedrop-list-max-height]="maxListHeight()"
      (click)="$event.stopPropagation()">
      @for (file of files(); track trackByFile($index, file)) {
        <div class="so-filedrop__file-item">
          <div class="so-filedrop__file-info">
            <so-svg-icon-ui
              [name]="getIconForFile(file)"
              [size]="24"
              [color]="getColorForFile(file)"
            ></so-svg-icon-ui>
            <div class="so-filedrop__file-details">
              <span class="so-filedrop__file-name" [title]="file.name">
                {{ file.name }}
              </span>
              <span class="so-filedrop__file-size">
                {{ formatFileSize(file.size) }}
              </span>
            </div>
          </div>
          <button 
            type="button"
            class="so-filedrop__remove-btn"
            (click)="removeFile($index); $event.stopPropagation()"
            [disabled]="effectiveDisabled()">
            <so-svg-icon-ui
              [name]="iconClose()"
              [size]="iconCloseSize()"
              [color]="'var(--so-danger-color, #dc3545)'">
            </so-svg-icon-ui>
          </button>
        </div>
      }
    </div>
  }

  @if (showMessage() && !hasFiles()) {
    <div class="so-filedrop__message">
      @if(showTitle()){
        <span class="so-filedrop__icon">{{ titleUpload() }}</span>
      }@else {
        <so-svg-icon-ui
          [name]="'cloud_upload'"
          [size]="24"
        ></so-svg-icon-ui>
      }
      <p class="so-filedrop__text">
        {{ dropText() }} 
        <span class="so-filedrop__or">{{ orText() }}</span>
        <strong class="so-filedrop__click-text">{{ clickText() }}</strong>
      </p>
      @if (showMaxFileSize()) {
        <div class="so-filedrop__size-info">
          <small>{{ maxMultimediaText() }}: {{ maxSizeMultimedia() }} {{ txtTypeSize() }}</small>
          <small>{{ maxDocText() }}: {{ maxSizeDocs() }} {{ txtTypeSize() }}</small>
        </div>
      }
    </div>
  }

  @if (showMessage() && hasFiles()) {
    <div class="so-filedrop__add-more" *ngIf="multiple()">
      <so-svg-icon-ui
        [name]="iconCircleAdd()"
        [size]="iconCircleAddSize()"
        [color]="'var(--so-primary-color, #007bff)'"
      ></so-svg-icon-ui>
      <span>{{ addMoreFilesText() }}</span>
    </div>
  }
</div>

@if (showButtonSave() && hasFiles() && !validateByModal()) {
  <div class="so-filedrop__actions">
    <button 
      type="button" 
      class="so-filedrop__save-btn"
      (click)="saveFiles()">
        <so-svg-icon-ui
        [name]="iconCheck()"
        [size]="iconCheckSize()"
        [color]="'var(--so-primary-color, #007bff)'"
      ></so-svg-icon-ui>
      <span>{{ btnAcceptText() }} </span>
    </button>
  </div>
}
